// TODO: switch to @wandb/weave/components/RadixTooltip once it exposes Arrow.
import * as Tooltip from '@radix-ui/react-tooltip';
import {Icon} from '@wandb/components';
import {Tailwind, TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';
import {
  Button as AriaButton,
  type ButtonProps as AriaButtonProps,
} from 'react-aria-components';

export const WBAgentChatButton = ({
  isLoading,
  showOnboardingCue,
  ...props
}: AriaButtonProps & {
  isLoading?: boolean;
  showOnboardingCue?: boolean;
}) => {
  const button = (
    <AriaButton
      aria-label={isLoading ? 'Workspace agent (loading)' : 'Workspace agent'}
      {...props}
      className="group relative rounded-full p-4 mr-8">
      {showOnboardingCue && (
        <span
          aria-hidden
          className="pointer-events-none absolute -inset-8 rounded-full bg-[radial-gradient(circle,_#CDF4F7_30%,_transparent_65%)] motion-safe:animate-pulse motion-reduce:opacity-60"
        />
      )}
      <div className="relative flex h-32 w-32 rounded-full items-center justify-center bg-teal-550 text-white outline outline-2 outline-transparent group-hover:outline-[#CDF4F7] group-focus-visible:outline-[#CDF4F7]">
        <span
          className={
            isLoading
              ? 'inline-flex animate-spin [animation-duration:4s]'
              : 'inline-flex'
          }>
          <Icon icon={isLoading ? 'loading' : 'lightboard-solid'} size="md" />
        </span>
      </div>
    </AriaButton>
  );

  if (!showOnboardingCue) {
    return <Tailwind>{button}</Tailwind>;
  }

  return (
    <Tailwind>
      <Tooltip.Provider>
        <Tooltip.Root open>
          <Tooltip.Trigger asChild>{button}</Tooltip.Trigger>
          <Tooltip.Portal>
            <TooltipContent
              side="bottom"
              sideOffset={8}
              className="night-aware z-[999999] rounded text-sm text-center leading-[140%] shadow-md bg-moon-900 p-12 text-moon-200 dark:bg-moon-50 dark:text-moon-800">
              Open W&amp;B Agent,
              <br />
              your ML research assistant
              <Tooltip.Arrow className="fill-moon-900 dark:fill-moon-50" />
            </TooltipContent>
          </Tooltip.Portal>
        </Tooltip.Root>
      </Tooltip.Provider>
    </Tailwind>
  );
};

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof Tooltip.Content>,
  React.ComponentPropsWithoutRef<typeof Tooltip.Content>
>((props, ref) => (
  <TailwindContents>
    <Tooltip.Content ref={ref} {...props} />
  </TailwindContents>
));
